import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { timeThursdays } from 'd3';
import { ToastrService } from 'ngx-toastr';
import Quill from 'quill';
import { Spinner } from 'src/app/core/services/spinner.service';
import { CustomValidator } from 'src/app/shared/directive/custom-validator';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { UrlModel, WelcomeMessageModel } from 'src/app/shared/model/srm.model';
import { SrmService } from '../../../../../../shared/service/srm.service';
const Bold = Quill.import('formats/bold');
Bold.tagName = 'b';
Quill.register(Bold, true);

const Size = Quill.import('attributors/style/size');
Size.whitelist = ['8px', '9px', '10px', '12px', '13px', '14px', '16px', '18px', '20px', '22px'];
Quill.register(Size, true);

const Font = Quill.import('formats/font');
Font.whitelist = ['GEInspiraRegular'];
Quill.register(Font, true);

@Component({
  selector: 'app-welcome-message',
  templateUrl: './welcome-message.component.html',
  styleUrls: ['./welcome-message.component.scss']
})
export class WelcomeMessageComponent implements OnInit {

  @ViewChild('fileInputImg') fileInputImg;
  @ViewChild('fileInputAva') fileInputAva;
  @ViewChild('quillFileRef') quillFileRef: ElementRef;
  meQuillRef: any;

  public quill: Quill;
  public avatarUrl: UrlModel = new UrlModel();
  public welcomeImgUrl: UrlModel = new UrlModel();
  public welcomeData: WelcomeMessageModel = new WelcomeMessageModel();
  public title: string;
  public message: string;
  public name: string;
  public jobTitle: string;
  public imgDefault = '/assets/images/icons/img_default.png';
  public welcomeMessageForm: FormGroup;
  public loading = true;
  public loadingAvatar = true;
  public coverImage: any;
  public avatarExist = false;
  public coverExist = false;
  public content: string;
  public limit = 2048;
  constructor(
    private spinner: Spinner,
    private srmService: SrmService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {
    this.initForm();
    this.initEditor();
    this.getwelcomeMessage();

    this.quill.on('text-change', (delta, oldDelta, source) => {
      if (this.quill.getLength() > this.limit) {
        this.quill.deleteText(this.limit, this.quill.getLength());
      }
    });
  }

  public initForm() {
    this.welcomeMessageForm = new FormGroup({
      id: new FormControl(this.welcomeData.id, [CustomValidator.required]),
      title: new FormControl(this.welcomeData.title, [CustomValidator.required]),
      message: new FormControl(this.content, [CustomValidator.required]),
      name: new FormControl(this.welcomeData.name, [CustomValidator.required]),
      jobTitle: new FormControl(this.welcomeData.jobTitle, [CustomValidator.required]),
      avatar: new FormControl(this.welcomeData.avatar, [CustomValidator.required]),
      image: new FormControl(this.welcomeData.image, [CustomValidator.required])
    });
  }

  public initEditor() {
    this.quill = new Quill('#editor', {
      theme: 'snow',
      modules: {
        toolbar: {
          container: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],

            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],

            [{ size: ['13px', '8px', '9px', '10px', '12px', '14px', '16px', '18px', '20px', '22px'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }],
            [{ font: ['InterRegular'] }],
            [{ align: [] }],

            ['clean'],
          ],
        }
      }
    });
  }

  onSelectFile(event, name) { // called each time file input changes
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (file.size > 10485760) {
        this.toastr.error(
          MESSAGE_TOAST.ERROR_CHOOSE_FILE_DOC_SIZE
        );
        return;
      }
      if (file.name.split('.')[file.name.split('.').length - 1] === 'svg') {
        this.toastr.error(
          MESSAGE_TOAST.FILE_TYPE_WRONG
        );
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const url = ((event.target) as FileReader).result;
        if (name === 'avatar') {
          this.avatarUrl.url = url;
          this.avatarUrl.file = file;
          this.fileInputAva.nativeElement.value = '';
        } else {
          this.welcomeImgUrl.url = url;
          this.welcomeImgUrl.file = file;
          this.coverImage = url;
          this.fileInputImg.nativeElement.value = '';
        }
        this.checkExistFile();
      };
    }
  }

  public getwelcomeMessage() {
    this.spinner.show();
    this.srmService.getWelcomeMessage().subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        this.welcomeData = res.data;
        this.content = res.data.message.trim();
        this.quill.clipboard.dangerouslyPasteHTML(0, this.content);
        this.initForm();
        this.welcomeMessageForm.controls.message.setValue(this.content);
        this.avatarUrl.url = this.welcomeData.avatar.resourceUrl || this.imgDefault;
        this.welcomeImgUrl.url = this.welcomeData.image.resourceUrl || this.imgDefault;
        this.coverImage = this.welcomeData.image.resourceUrl || '';
        this.checkExistFile();
      }
    });
  }

  public updateWelcomeMessage() {
    this.content = this.quill.root.innerHTML.trim();
    this.welcomeMessageForm.controls.message.setValue(this.content);
    if ((this.quill as any).editor.isBlank()) {
      this.content = '';
      return;

    }
    if (!this.welcomeMessageForm.valid) {
      this.markFormGroupTouched(this.welcomeMessageForm);
      return;
    }
    if (this.welcomeImgUrl.url.localeCompare(this.imgDefault) !== 0 && this.avatarUrl.url.localeCompare(this.imgDefault) !== 0) {
      if (this.avatarUrl.url.localeCompare(this.welcomeData.avatar.resourceUrl) === 0) {
        this.avatarUrl.file = '';
      }
      if (this.welcomeImgUrl.url.localeCompare(this.welcomeData.image.resourceUrl) === 0) {
        this.welcomeImgUrl.file = '';
      }
      this.spinner.show();
      this.srmService.updateWelcomeMesage(this.welcomeMessageForm.getRawValue(), this.avatarUrl.file, this.welcomeImgUrl.file)
        .subscribe((res: any) => {
          this.spinner.hide();
          if (res.success) {
            this.toastr.success(MESSAGE_TOAST.UPDATE_WELCOME_MESAGE_SUCCESS);
            this.spinner.show();
            location.reload();
          }
        });
    }

  }

  public remove(name) {
    if (name === 'avatar') {
      this.avatarUrl.url = this.imgDefault;
      this.avatarExist = false;
      this.fileInputAva.nativeElement.value = '';
    } else {
      this.welcomeImgUrl.url = this.imgDefault;
      this.coverImage = '';
      this.coverExist = false;
      this.fileInputImg.nativeElement.value = '';
    }
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  public onLoad() {
    this.loading = false;
  }

  public onLoadAvatar() {
    this.loadingAvatar = false;
  }

  public checkExistFile() {
    if (this.avatarUrl.url.localeCompare(this.imgDefault) !== 0) {
      this.avatarExist = true;
    }
    if (this.welcomeImgUrl.url.localeCompare(this.imgDefault) !== 0) {
      this.coverExist = true;

    }
  }

}
